import { ZOOM_MIN, ZOOM_MAX } from './_pan-zoom.params';
import { usePanZoomContext } from './_pan-zoom.provider';

export const usePanZoomWheel = () => {
  const { frameEl, zoomEl, zoomRectDiff } = usePanZoomContext();

  const validateZoom = (value: number) => {
    return value < ZOOM_MIN ? ZOOM_MIN : value > ZOOM_MAX ? ZOOM_MAX : value;
  };

  return (step: Fraction) => {
    if (!zoomEl.current || !frameEl.current) return;
    const frameRect = frameEl.current.getBoundingClientRect();
    const zoomRect = zoomEl.current.getBoundingClientRect();

    const curr = {
      left: frameRect.left - zoomRect.left,
      top: frameRect.top - zoomRect.top,
      right: zoomRect.right - frameRect.right,
      bottom: zoomRect.bottom - frameRect.bottom,
    };

    const zoomPrev = frameRect.width / zoomRect.width;
    const zoom = validateZoom(zoomPrev + step);
    const zoomStep = zoom - zoomPrev;

    const stepW = (zoomRect.width * zoomStep) / 2;
    const stepH = (zoomRect.height * zoomStep) / 2;

    let left = curr.left > stepW ? curr.left - stepW : 0;
    let bottom = curr.bottom > stepH ? curr.bottom - stepH : 0;

    if (zoomStep > 0) {
      if (stepW >= curr.right) left -= stepW;
      if (stepH >= curr.top) bottom -= stepH;
    }

    left += zoomRectDiff.current.left;
    bottom += zoomRectDiff.current.bottom;

    return { left, bottom, zoom };
  };
};
